/**
    Sqills and DB cannot handle 
    POST customer, as a result, a fake customer 
    is added during booking creation on the back-end
    for DB bookings.
    We need to identify those and PATCH them instead in the booking flow
 */

const CUSTOMER_FAKE_FIRST_NAME = 'TEST';
const CUSTOMER_FAKE_LAST_NAME = 'customer';
const CUSTOMER_FAKE_EMAIL = 'db.customer@testing.eurostar.com';
const CUSTOMER_FAKE_PHONE_NUMBER = '+447524857769';

export const isFakeCustomer = ({ firstName, lastName, email, phoneNumber }) =>
  firstName === CUSTOMER_FAKE_FIRST_NAME &&
  lastName === CUSTOMER_FAKE_LAST_NAME &&
  email === CUSTOMER_FAKE_EMAIL &&
  phoneNumber === CUSTOMER_FAKE_PHONE_NUMBER;
